import React from "react";  
import { motion } from "framer-motion";  
  
const AdminStatCard = ({ label, value, sub, valueColor = "text-white", onClick, index = 0 }) => (  
  <motion.div  
    initial={{ opacity: 0, y: 8 }}  
    animate={{ opacity: 1, y: 0 }}  
    transition={{ delay: index * 0.03 }}  
    whileHover={onClick ? { y: -1 } : undefined}  
    onClick={onClick}  
    className={`bg-gradient-to-br from-gray-900/60 via-black/60 to-gray-900/60 backdrop-blur-xl border border-gray-800 rounded-2xl p-5 transition-all ${  
      onClick ? "cursor-pointer hover:border-gold/30" : ""  
    }`}  
  >  
    <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 mb-2">{label}</p>  
    <p className={`text-2xl sm:text-3xl font-bold leading-none ${valueColor}`}>{value}</p>  
    {sub && <p className="text-[11px] text-gray-500 mt-2">{sub}</p>}  
  </motion.div>  
);  
  
export default AdminStatCard;  